<template>
    <div v-if="item" class="md-content">
        <toolbar title="Édition du produit" isSave="true" @save="dataSave" />

        <div class="md-mt-5 md-layout md-gutter md-alignment-top-center">
            <div class="md-layout-item md-size-90 md-layout ">
                <div class="md-layout-item md-size-50 ">
                    <field-image v-bind:item.sync="item" property="image" type="Image" :readonly="false"  />
                </div>
                <div class="md-layout-item md-size-50">
                    <div class="md-layout md-alignment-top-right">
                        <md-switch v-model="item.isActive" class="md-primary" disabled>Actif</md-switch>
                    </div>
                </div>
            </div>


            <div class="md-layout-item md-size-45 md-small-size-90 ">
                <md-field :class="$v.item.name|validations">
                    <label for="txtName">Nom</label>
                    <md-input id="txtName" v-model="item.name" type="text" required />
                </md-field>
                <md-field>
                    <label>Identifiant unique</label>
                    <md-input v-model="item.uId" type="text" />
                </md-field>

                <field-category title="Catégorie" v-bind:item.sync="item" property="categoryId" :defaultValue="null" sourceURI="sale/productcategories" :expand="false" :readonly="false" id="SaleProductEdit_fld-Category" :class="$v.item.categoryId|validations" />
                <md-field >
                    <label>Autre catégorie</label>
                    <md-input v-model="item.otherCategoryId" type="text" />
                </md-field>
                
                <div class="md-layout md-gutter md-alignment-top-left">
                    <div class="md-layout-item md-size-50 md-small-size-90 ">
                        <md-field :class="$v.item.price|validations">
                            <label for="txtPrice ">Prix</label>
                            <md-input id="txtPrice" v-model.number="item.price" type="text" />
                        </md-field>
                    </div>
                    <div class="md-layout-item md-size-50 md-small-size-90 ">
                        <md-field :class="$v.item.qty|validations">
                            <label for="txtQty">Quantité</label>
                            <md-input id="txtQty" v-model.number="item.qty" type="text" />
                        </md-field>
                    </div>
                </div>
                <div class="md-layout md-gutter md-alignment-top-left">
                    <div class="md-layout-item md-size-50 md-small-size-90 ">
                        <md-field class="">
                            <label for="txtSKU">SKU</label>
                            <md-input id="txtSKU" v-model="item.sku" type="text" />
                        </md-field>
                    </div>
                    <div class="md-layout-item md-size-50 md-small-size-90 ">
                        <md-field class="">
                            <label for="txtUPC">UPC</label>
                            <md-input id="txtUPC" v-model="item.upc" type="text" />
                        </md-field>
                    </div>
                </div>
            </div>
            <div class="md-layout-item md-size-45 md-small-size-90 ">

                <div class="md-layout md-layout-item md-size-90 ">
                    <span class="md-title">Titre / Description</span>
                </div>
                <md-field>
                    <md-input v-model="item.title" type="text" placeholder="Titre" />
                </md-field>
                <md-field>
                    <md-textarea v-model="item.description" type="textarea" placeholder="Description" md-autogrow />
                </md-field>
                <span class="md-caption">I18N: {{item.i18N}}</span>

                
                <div class="md-layout md-layout-item md-size-90 md-mt-3 ">
                    <span class="md-title">Comptabilité</span>
                </div>

                <div class="md-layout md-gutter md-alignment-top-left">
                    <div class="md-layout-item md-size-50 md-small-size-90 ">
                        <md-field class="">
                            <label for="txtAccountingNumbe">Numéro</label>
                            <md-input id="txtAccountingNumbep" v-model="item.accountingNumber" type="text" />
                        </md-field>
                    </div>
                    <div class="md-layout-item md-size-50 md-small-size-90 ">
                        <md-field class="">
                            <label for="txtAccountingGroup">Groupe</label>
                            <md-input id="txtAccountingGroup" v-model="item.accountingGroup" type="text" />
                        </md-field>
                    </div>
                </div>

                <md-switch v-model="item.gstApplied" class="md-primary">TPS</md-switch>
                <md-switch v-model="item.pstApplied" class="md-primary">TVP</md-switch>

                <div class="md-layout md-layout-item md-size-90 title md-mt-3">
                    <span class="md-title">Commentaires</span>
                    <md-field>
                        <md-textarea name="txtComment" id="txtComment" v-model="item.comment" type="textarea" md-autogrow />
                    </md-field>
                </div>

            </div>

            <div class="md-layout-item md-size-90 md-mt-5 ">
                <span class="md-caption">Modifié&nbsp;le:&nbsp;{{item.modifiedOn| YYYYMMDD}} </span>
                <span class="md-caption">Par:&nbsp;{{item.modifiedBy}}</span>
            </div>
            <div class="md-layout-item md-size-90 ">
                <span class="md-caption">Créé&nbsp;le:&nbsp;{{item.createdOn| YYYYMMDD}} </span>
                <span class="md-caption">Par:&nbsp;{{item.createdBy}}</span>
            </div>
        </div>
    </div>
</template>
<style>
    #SaleProductEdit_fld-Category.md-invalid div.md-field label {
        color: red;
    }
</style>
<style scoped>
</style>
<script>
    import baseToolbar from '@/components/toolbarBase.vue';
    import { required, numeric, minValue, decimal } from 'vuelidate/lib/validators';

    import field_category from '@/components/field-select-wd.vue';
    import field_image from '@/components/field-image-wd.vue';

    import { beforeRouteLeaveExtension } from '@/mixins/beforeRouteLeaveExtension.js';
    import { navigateRouteExtension } from '@/mixins/navigateRouteExtension.js';
    import { apiSaleProductExtension } from '@/mixins/apiSaleProductExtension.js';

    export default {
        name: 'productEdit',
        mixins: [beforeRouteLeaveExtension, navigateRouteExtension, apiSaleProductExtension],
        data: () => ({
            item: null,
            //showDialog: false

        }),
        watch: {
            item: {
                deep: true,
                handler(item) {
                    if (this.$v.$init && !this.$v.$anyDirty) { this.$v.$touch(); }
                    else { this.$v.$init = true; }
                }
            }
        },
        validations: {
            item: {
                name: { required },
                categoryId: {required, minValue: minValue(1)},
                qty: { numeric, minValue: minValue(0) },
                price: { decimal }
            }
        },
        created: function () {
            $App.event.$on("app_hotkey_ctrlS", this.onCtrlS);
        },
        destroyed: function () {
            $App.event.$off("app_hotkey_ctrlS", this.onCtrlS);
        },
        mounted:
            async function () {
                await this.dataRead();
            },
        methods: {
            dataRead: async function () {

                let data = await this.SaleProductGetById(this.$route.params.id);
                if (data) {
                    this.item = data;
                }
            },
            dataSave: async function () {

                this.$v.$touch()
                if (!this.$v.$invalid) {

                    let data = await this.SaleProductSave(this.item);
                    if (data) {
                        this.$v.$reset();
                        this.navigateBack({ name: 'product_List' });
                    }
                }
            },
            // uploadImage(e) {
            //     const fileSelected = e.target.files[0];
            //     // to keep view model object available in pure javascript...
            //     var vm = this.item;
            //     vm.image.path = fileSelected.name;
            //     PictureFileOptimizeToDataURL(fileSelected, function (dataURL) { 
            //         vm.image.encoding = 'DataUrl';
            //         vm.image.content = dataURL; 
            //     });
            // },
            // chooseFiles() {
            //     document.getElementById("fileUpload").click()
            // },
            onCtrlS: function (e) {
                this.dataSave();
            },
        },
        components: {
            toolbar: baseToolbar,
            'field-category': field_category,
            'field-image' : field_image
        }
    }
</script>